import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { Notario, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { StrapiResponseModel, NotarioModel } from '@/interfaces/model';
import { notariosListMapper } from '@/mappers';

export const getNotarios = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<Notario>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/notarios',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<NotarioModel>;
					return notariosListMapper(json);
				},
			],
		}),
		controller,
	};
};
